'use es6';

import Application from './App';
require.context('bender-url!../images', true);
new Application().start();